import { Tab, Tabs } from '@material-ui/core';
import TabPanel from 'components/common/tab/TabPanel';
import cx from 'classnames';
import React, { useContext, useEffect } from 'react';
import styled from 'styled-components';
import { PrivateSocketContext } from 'contexts/PrivateSocketContext';
import { ProjectSocketContext } from 'contexts/ProjectSocketContext';
import { useDidUpdateEffect } from 'lib/utils';
import { useProjectDetailStore } from 'store/local/projectDetail';
import { color } from 'styles/utils';
import { a11yProps } from 'lib/library';
import ProjectContentsInfo from './ProjectContentsInfo';
import ProjectContentsFile from './ProjectContentsFile';
import ProjectContentsExtra from './ProjectContentsExtra';
import { useProjectFiles } from 'lib/hooks/project/useProjectFiles';
import { useProjectFileStore } from 'store/local/projectFile';
import { useProject } from 'lib/hooks/project/useProject';

function ProjectContents() {
  // SECTION: state
  const { projectAcceptEvent } = useContext(PrivateSocketContext);
  const { newProjectChat, isChatOpen } = useContext(ProjectSocketContext);
  const { currentTab } = useProjectDetailStore();
  const { projectTabList, fetchProjectSuccess, deleteProjectFileSuccess, handleClickProjectTab } =
    useProject();
  const {
    handleClearAllCheckbox,
    handleRemoveViewLocalFileController,
    handleRemoveViewCloudFileController,
  } = useProjectFiles();
  const { localFileDeleteSuccess } = useProjectFileStore();

  useDidUpdateEffect(() => {
    if (!fetchProjectSuccess) return;
    handleClearAllCheckbox();
  }, [fetchProjectSuccess]);

  useEffect(() => {
    if (!deleteProjectFileSuccess) return;
    handleRemoveViewCloudFileController();
  }, [deleteProjectFileSuccess]);

  useEffect(() => {
    if (!localFileDeleteSuccess) return;
    handleRemoveViewLocalFileController();
    handleClearAllCheckbox();
  }, [!!localFileDeleteSuccess]);

  return (
    <StyledProjectContents data-component-name="ProjectContents">
      <div className="project__tabs_box">
        <Tabs
          value={currentTab}
          onChange={(e: any, value: any) => {
            handleClickProjectTab(value);
          }}
          aria-label="myproduct tabs"
          className="project__tabs"
        >
          {projectTabList.map((item: string, idx: number) => (
            <Tab
              className={cx('project__tab_item')}
              key={idx}
              label={item}
              disableRipple
              {...a11yProps(idx, 'myProjectTab')}
            />
          ))}
        </Tabs>
        <ProjectContentsExtra />

        <TabPanel
          value={currentTab}
          index={0}
          name="myProjectTab"
          className="project__tab_tabpanel"
        >
          <ProjectContentsInfo />
        </TabPanel>
        <TabPanel
          value={currentTab}
          index={1}
          name="myProjectTab"
          className="project__tab_tabpanel"
        >
          <ProjectContentsFile />
        </TabPanel>
      </div>
    </StyledProjectContents>
  );
}

const StyledProjectContents = styled.div`
  margin: 0 auto;
  width: 100%;

  .project__tabs_box {
    position: relative;
    width: inherit;
    background-color: #fff;
    border: 1px solid ${color.border_line};
    box-shadow: 4px 4px 10px 0px rgba(0, 0, 0, 0.16);
    border-radius: 10px;
    .project__tabs {
      width: inherit;
      border-radius: 10px 10px 0 0;

      .MuiTabs-indicator {
        display: none;
      }
      .project__tab_item {
        width: 240px;
        min-height: 52px;
        text-transform: capitalize;
        border-right: none;
        background-color: ${color.back_ground_bg};
        border-bottom: 1px solid ${color.border_line};

        &:nth-child(1) {
          &.Mui-selected {
            border-right: 1px solid ${color.border_line};
          }
        }

        &:nth-child(2) {
          &.Mui-selected {
            border-left: 1px solid ${color.border_line};
          }
        }

        &.Mui-selected {
          background-color: #fff;
          border-bottom: none;
          color: #00a6e2;
        }
      }
    }
    .tabs_empty_margin {
      position: absolute;
      top: 0;
      right: 0;
      height: 52px;
      border-left: 1px solid ${color.border_line};
      border-bottom: 1px solid ${color.border_line};
      width: calc(100% - 480px);
      z-index: 1;
    }
  }
`;

export default ProjectContents;
